import React from 'react';
import './ProTip.css';

const ProTip = ({ title = 'Pro Tip', children }) => {
  if (!children) return null;

  return (
    <div className="pro-tip">
      <div className="pro-tip__icon">💡</div>
      <div>
        <h4>{title}</h4>
        <div className="pro-tip__content">{children}</div>
      </div>
    </div>
  );
};

export default ProTip;
